import React, { PureComponent } from 'react';
import { Form, FormGroup } from '../../../../components/Forms/Forms';
import { Input, Select } from '../../../../components/Forms/fields';
import enums from '../../../../constants/enums';

class PaymentFiltersView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    let {
      cardTypes,
      onFilterChange,
      filtersFormState,
    } = this.props;

    return (
      <div className="filters-container admin-payment-filters-view">
        <Form state={filtersFormState} onSubmit={()=>{}} onChange={onFilterChange}>
          <FormGroup>
            <label>Type:</label>
            <Select name="type" options={cardTypes} selectLabel="-" emptyOption/>
          </FormGroup>
          <FormGroup>
            <label>Status:</label>
            <Select name="status" options={enums.paymentStatus} selectLabel="-" emptyOption/>
          </FormGroup>
          <FormGroup>
            <label>Code:</label>
            <Input name="code" type="text"/>
          </FormGroup>
          <FormGroup>
            <label>Sort By:</label>
            <Select name="sort" options={enums.paymentSortOptions} />
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default PaymentFiltersView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/PaymentFilters/PaymentFilters.view.js